<script setup lang="ts">
import { PublicSellerFaqQuery } from '@gql/PublicSellerFaqQuery'

const t2 = useT2({
  Faq: 'DUK',
})
// const mobile = useMobile()
const { myLink } = useLinks()
const sellerId = useSellerId('retail')

const params = useParams((i, route) => ({
  rounteName: myLinkName(route),
  slug: helpers.unArray(i.slug),
  slug2: helpers.unArray(i.slug2),
}))

const { ui: faqFull } = useApolloWrap2<gen.PublicSellerFaqQuery, gen.PublicSellerFaqQueryVariables>(PublicSellerFaqQuery)({
  vars: () => ({ sellerId: sellerId.value }),
  ui: (i) => helpers.arr(i?.publicSellerFaq),
})

// const slugfaq = computed((): string | undefined => {
//   const { rounteName, slug } = params.value
//   if (!helpers.isIn(rounteName, 'info-faq-slug-slug2', 'info-faq-slug', 'info-faq')) return
//   return slug || helpers.arrFind(faqFull.value, (i) => i.section.slug)
// })

// const activeSection = computed(() => {
//   const list = faqFull.value
//   return helpers.arrFindId(list, slugfaq.value, (i) => i.section.slug) || list?.at(0)
// })

// watch(() => activeSection.value, (i) => mobile.value && i && utilsScrollTop())

useHead({
  title: t2('Faq'),
})
if (import.meta.server) {
  useHead(() => {
    const mainEntity: Record<string, unknown>[] = []

    for (const questions of faqFull.value) {
      if (questions?.questions?.length) {
        for (const item of questions.questions) {
          if (item.title.value?.length && item.text?.value?.length) {
            mainEntity.push({
              '@type': 'Question',
              name: item.title.value,
              acceptedAnswer: { '@type': 'Answer', text: item.text?.value },
            })
          }
        }
      }
    }

    return {
      script: [seoSchema({ '@type': 'FAQPage', mainEntity })],
    }
  })
}
</script>

<template>
  <AppMenu :title="ts(t2('Faq'))" :breadcrums="() => [{ title: t2('Faq'), to: myLink('info-faq', {}) }]">
    <!-- activeSection?.section?.title?.value ??  -->
    <!-- <InputInfoSearch :class="$style.search" /> -->
    <!-- <template #nav>
      <h2  :pt="mobile ? undefined : '8'" :pl="mobile ? '014' : '2'" pb="2" :txt="t2('Faq')" />
      <LinkTablet
        v-for="item in faqFull"
        :id="item.id"
        :key="item.id"
        :to="myLink('info-faq-slug', { slug: item.section.slug })"
        :txt="ts(item.section.title.value)"
        :class="$style.link"
        :active="!!slugfaq && item.section.slug === slugfaq"
      />
    </template> -->

    <div v-for="(item, index) in faqFull" :key="item.id">
      <h2 v-if="item.section.title.value" class="_pb3 _pl1" :class="[index && '_pt8']">{{ item.section.title.value }}</h2>
      <InfoBoxes
        :items="item?.questions"
        :model-value="params.slug2"
        :ui="
          (i) => ({
            key: i.slug,
            title: i.title.value,
            hasContent: true,
            to: myLink('info-faq-slug-slug2', { slug: item?.section.slug, slug2: i.slug }),
            back: myLink('info-faq-slug', { slug: item?.section.slug }),
          })
        "
      >
        <template #default="{ item: item123 }">
          <LazyInfoFaqDoc :item="item123" />
        </template>
      </InfoBoxes>
    </div>
  </AppMenu>
</template>
